import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../config";

const API_URL = config.API_URL;


export default function PortalHome() {
  const navigate = useNavigate();
  const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
  const [triggerWatchEnabled, setTriggerWatchEnabled] = useState(false);

  useEffect(() => {
    const orgId = storedUser.organization_id;
    if (!orgId) return;
    axios.get(`${API_URL}/platform-settings/triggerwatch_enabled?org_id=${orgId}`)
      .then(res => setTriggerWatchEnabled(res.data.value === "true"))
      .catch(() => setTriggerWatchEnabled(false));
  }, []);

  function getInitials() {
    if (storedUser.full_name) {
      const parts = storedUser.full_name.split(" ");
      return parts.map(p => p[0]).join("").toUpperCase().slice(0, 2);
    }
    return storedUser.email ? storedUser.email[0].toUpperCase() : "?";
  }

  function handleSignOut() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    window.location.href = "/login";
  }

  return (
    <div className="min-h-screen bg-gray-950 flex flex-col items-center justify-center px-6 py-12">

      {/* Header */}
      <div className="text-center mb-10">
        <div className="flex items-center justify-center mb-4">
          <img src="/logo-white.png" alt="AleroSys" className="h-20 w-auto" />
        </div>
        <h1 className="text-2xl font-bold text-white mb-2">Your portal</h1>
        <p className="text-gray-400 text-sm">Select a tool to get started</p>
      </div>

      {/* Tool cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-2xl mb-6">

        {/* DriverWatch — active */}
        <div
          onClick={() => navigate("/")}
          className="bg-gray-900 border border-blue-700 rounded-xl p-6 cursor-pointer hover:border-blue-500 hover:bg-gray-800 transition-all"
        >
          <div className="w-11 h-11 bg-blue-900 rounded-xl flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <rect x="7" y="7" width="10" height="10" rx="1"/>
              <path d="M9 7V4M12 7V4M15 7V4M9 20v-3M12 20v-3M15 20v-3M4 9h3M4 12h3M4 15h3M17 9h3M17 12h3M17 15h3"/>
            </svg>
          </div>
          <p className="text-white font-semibold text-sm mb-1">DriverWatch</p>
          <p className="text-gray-400 text-xs mb-4 leading-relaxed">Driver health monitoring for Windows fleets</p>
          <span className="bg-green-900 text-green-300 text-xs px-2 py-1 rounded-full">Active</span>
        </div>

        {/* TriggerWatch — active once the platform flag is enabled */}
        <div
          onClick={() => { if (triggerWatchEnabled) navigate("/triggerwatch"); }}
          className={`bg-gray-900 rounded-xl p-6 transition-all ${
            triggerWatchEnabled
              ? "border border-purple-700 cursor-pointer hover:border-purple-500 hover:bg-gray-800"
              : "border border-gray-800 opacity-60"
          }`}
        >
          <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 ${triggerWatchEnabled ? "bg-purple-900" : "bg-gray-800"}`}>
            <svg className={`w-6 h-6 ${triggerWatchEnabled ? "text-purple-400" : "text-gray-600"}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <rect x="2" y="3" width="20" height="14" rx="2"/>
              <path d="M8 21h8M12 17v4"/>
            </svg>
          </div>
          <p className={`font-semibold text-sm mb-1 ${triggerWatchEnabled ? "text-white" : "text-gray-300"}`}>TriggerWatch</p>
          <p className="text-gray-500 text-xs mb-4 leading-relaxed">Package deployment tooling</p>
          {triggerWatchEnabled ? (
            <span className="bg-green-900 text-green-300 text-xs px-2 py-1 rounded-full">Active</span>
          ) : (
            <span className="bg-gray-800 text-gray-500 text-xs px-2 py-1 rounded-full border border-gray-700">Coming soon</span>
          )}
        </div>

        {/* Tool 3 — coming soon */}
        <div className="bg-gray-900 border border-gray-800 rounded-xl p-6 opacity-60">
          <div className="w-11 h-11 bg-gray-800 rounded-xl flex items-center justify-center mb-4">
            <svg className="w-6 h-6 text-gray-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <line x1="18" y1="20" x2="18" y2="10"/>
              <line x1="12" y1="20" x2="12" y2="4"/>
              <line x1="6" y1="20" x2="6" y2="14"/>
            </svg>
          </div>
          <p className="text-gray-300 font-semibold text-sm mb-1">Tool 3</p>
          <p className="text-gray-500 text-xs mb-4 leading-relaxed">Reporting and analytics</p>
          <span className="bg-gray-800 text-gray-500 text-xs px-2 py-1 rounded-full border border-gray-700">Coming soon</span>
        </div>

      </div>

      {/* User info bar */}
      <div className="w-full max-w-2xl bg-gray-900 border border-gray-800 rounded-xl px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center text-white text-xs font-bold">
            {getInitials()}
          </div>
          <div>
            <p className="text-white text-sm font-medium">{storedUser.full_name || "User"}</p>
            <p className="text-gray-500 text-xs">{storedUser.email} · {storedUser.role}</p>
          </div>
        </div>
        <button
          onClick={handleSignOut}
          className="text-red-400 hover:text-red-300 text-sm transition-colors"
        >
          Sign out
        </button>
      </div>

    </div>
  );
}
